/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://4btbmpap45f2fg2tvslyt2unn4.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-c3s62fsvmrg3zgzcfqvzb6m7o4",
    "aws_cloud_logic_custom": [
        {
            "name": "developerApi",
            "endpoint": "https://b9py21ezc7.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:e360eed1-b76e-421a-9dee-583f7e90894f",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_A4ZBgY6MI",
    "aws_user_pools_web_client_id": "3n7cdt02hb0emqj9hg6vvef7qa",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "cssharedapp-20220816212241-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://dl1wtftrijypg.cloudfront.net"
};


export default awsmobile;
